<template>
  <div class="relative">
    <label 
      v-if="isPatientUpdate" 
      :class="{ 'selector-label': !isExpressCheckoutPpnDialog }"
      >
      {{ $t("OrderPage[\"Country\"]") }}
    </label>
    <el-select
      v-model="country"
      :class="['order-test', { error: isCountryError }]"
      :disabled="isAddOnOrder.length > 0"
      filterable
      :filter-method="filterCountryOptions"
      @change="countryChange"
    >
      <el-option
        v-for="c in filteredCountryOptions"
        :key="c.value"
        :label="c.label"
        :value="c.value"
      />
    </el-select>
    <p v-if="unsupportedCountruWarning" class="unsupport-country-warning mt-1">
      {{ unsupportedCountruWarning }}
    </p>
  </div>
</template>

<script>
import { filterCountry } from "@/utils/va-order-test/filterCountry.js";
import { getUnsupportedCountryWarning } from "@/views/va-orderTest/user-selection/patient-container/create-patient/createPatientForm.js";
import { mapState } from "vuex";

export default {
  props: {
    patientCountry: {
      type: String,
      default: "US"
    },
    isPanelExpand: {
      type: Boolean,
      default: false
    },
    isPatientUpdate: {
      type: Boolean,
      default:true,
    },
    changeCount: {
      type: Number,
      default: 0,
    },   
    isExpressCheckoutPpnDialog: {
      type: Boolean,
      default: false
    }      
  },

  data() {
    return {
      country: this.patientCountry,
      filteredCountryOptions: this.$store.state.orderTest.countryOptions,
    }
  },

  computed: {
    ...mapState("orderTest",["countryOptions","isAddOnOrder", "defaultSettings"]),

    isCountryError() {
      return this.isPanelExpand && !this.country;
    },

    unsupportedCountruWarning() {
      return getUnsupportedCountryWarning(this.country, this.countryOptions);
    },
  },

  watch: {
    countryOptions(newVal) {
      this.filteredCountryOptions = newVal;
    },
    changeCount(newVal) {
      if (newVal >0) {
        this.country = this.patientCountry;
      }
    },
    patientCountry(newVal) {
      this.country = newVal;
    }
  },

  methods: {
    filterCountryOptions(input) {
      this.filteredCountryOptions = filterCountry(input, this.countryOptions);
    },

    countryChange() {
      this.$emit("countryChange", {prop: "country", value: this.country, notice: true});
    },
  }
}
</script>

<style scoped>
.selector-label {
  position: absolute;
  left: 16px;
  top: 2px;
  background-color: transparent;
  z-index: 10;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.125px;
  color: #9B9B9B;
}

.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  color: #20A8C3;
}

.el-select-dropdown__item.selected {
  color: #20A8C3;
}

.error {
  border-color: red;
  color: red;
}

.unsupport-country-warning {
  color: #D5993D;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>